<template>
  <div
    class="modal fade"
    id="changePlan"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelTitleId"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content modal-subscription">
        <div class="modal-header">
          <button
            period="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div class="modal-body pt-2">
          <div class="row">
            <div class="col-12 text-left">
              <h1 class="plan-subheader">Resumen de compra</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="row mt-2">
                <div class="col-12">
                  <div class="plan-remark">
                    Plan {{ selectedPlan.subscription.name }}
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <p class="plan-description">
                    {{ selectedPlan.subscription.description }}
                  </p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div>
                    <span class="plan-primary">Forma de cobro:</span>
                    <span
                      class="ml-1 plan-secondary"
                      v-if="selectedPlan.period == 1"
                      >mensual</span
                    >
                    <span class="ml-1 plan-secondary" v-else>anual</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div>
                    <span class="plan-primary">Fecha de inicio:</span>
                    <span class="ml-1 plan-secondary">{{ dateStart }}</span>
                  </div>
                </div>
              </div>
              <div class="row mt-4 mb-3">
                <div class="col-12">
                  <div
                    class="pb-2"
                    style="border-bottom: solid 1px lightgray; width: fit-content;"
                  >
                    <span class="plan-primary light">Próximo pago:</span>
                    <span
                      class="plan-primary light ml-1"
                      v-if="selectedPlan.period == 2"
                      >{{ dateEndYear }}</span
                    >
                    <span class="plan-primary light ml-1" v-else>{{
                      dateEndMonth
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div>
                    <span class="plan-primary lg">Total:</span>
                    <span class="plan-primary lg ml-1">
                      {{ pricing.price | currency }}
                      {{ pricing.currency.toUpperCase() }}
                    </span>
                  </div>
                  <span
                    class="plan-primary light"
                    v-if="selectedPlan.period == 1"
                    >Suscripción mensual</span
                  >
                  <span class="plan-primary light" v-else
                    >Suscripción anual</span
                  >
                </div>
              </div>
            </div>

            <div
              class="col-6 text-left px-5"
              style="border-left: solid 1px lightgray;"
            >
              <div class="row">
                <div class="col-12">
                  <div>
                    Método de pago:
                    <strong
                      >{{ planDetails.plan_detail.brand }} **** **** ****
                      {{ planDetails.plan_detail.last_four }}</strong
                    >
                  </div>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12">
                  <button
                    type="button"
                    class="btn btn-save form-control text-center text-uppercase"
                    @click="changePlan()"
                  >
                    <span
                      >Pagar {{ pricing.price | currency }}
                      {{ pricing.currency.toUpperCase() }}</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import filters from "@/mixins/filters";
import data from "@/mixins/data";
import plansService from "@/api/plans";

export default {
  mixins: [filters, data],
  mounted() {},
  beforeDestroy() {
    $(".modal-backdrop").remove();
  },
  props: {
    selectedPlan: {
      required: true,
    },
  },
  data() {
    return {
      dateStart: moment().format("ll"),
      dateEndYear: moment()
        .add(1, "year")
        .format("ll"),
      dateEndMonth: moment()
        .add(1, "month")
        .format("ll"),
      planSelected: "",
    };
  },

  computed: {
    pricing() {
      const frecuency = this.selectedPlan.period == 1 ? "month" : "year";

      const price = this.selectedPlan.subscription.prices.find(
        (price) => price.recurring === frecuency
      );

      return price;
    },
  },

  methods: {
    handleSelectPlan() {
      switch (this.selectedPlan.period) {
        /* Mensual */
        case 1:
          /* Plan Personal */
          if (this.selectedPlan.plan == 2) {
            this.planSelected = "individual_month";
          }

          if (this.selectedPlan.plan == 3) {
            this.planSelected = "team_month";
          }
          break;

        /* Anual */
        case 2:
          if (this.selectedPlan.plan == 2) {
            this.planSelected = "individual_year";
          }

          if (this.selectedPlan.plan == 3) {
            this.planSelected = "team_year";
          }
          break;
      }
    },
    changePlan() {
      this.handleSelectPlan();
      this.$store.dispatch("showLoader", { show: true });
      let data = {
        plan: this.planSelected,
      };
      plansService.subscribePlan(data).then(() => {
        this.$store.dispatch("client/setData").then(() => {
          $(".modal-backdrop").remove();
          $("#changePlan").modal("hide");
          this.$store.dispatch("showLoader", { show: false });
        });
      });
    },
  },
};
</script>
